<template>
  <div class="button-edit py-2 px-4">
    <rich-text-input :placeholder="$t('imageedit_enter_image_url')" :content.sync="imageSrc" mode="url" :json.sync="editorContentJson" :label="$t('imageedit_image_url')"></rich-text-input>
  </div>
</template>

<script>
import RichTextInput from '@/components/utils/RichTextInput'
import { removeHtmlTags } from '@/utils/configHelpers'

export default {
  name: 'ImageEdit',
  props: ['src', 'json', 'isTranslationEdit'],
  components: {
    'rich-text-input': RichTextInput
  },
  watch: {
    imageSrc (newVal) {
      if (this.isTranslationEdit) {
        this.$emit('update:content', removeHtmlTags(this.imageSrc))
      }
    }
  },
  data () {
    return {
      imageSrc: '',
      editorContentJson: {}
    }
  },
  created () {
    this.imageSrc = this.src
    if (typeof this.imageSrc !== 'string') {
      this.imageSrc = ''
    }
  }
}
</script>

<style lang="sass">

</style>
